import ComponentLayout from '~/src/layouts/component-layout';
import { Text } from '@primer/react';
import * as React from 'react';
export default {
  ComponentLayout,
  Text,
  React
};